<template>
  <div class="liftManage">
    <div class="titleWrap">
      <div class="setTitle">电梯列表</div>
      <el-button class="myBtn" type="primary" plain size="small" v-if="funcData.indexOf('export') > -1" @click="exportLift" style="margin-left: 10px;">导出</el-button>
      <el-upload class="myBtn" :action="importLiftUrl" :headers="myHeaders" :show-file-list="false" accept=".xls, .xlsx" :on-success="uploadSuccess" :on-error="uploadError" style="margin-left: 10px;">
        <el-button type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1">导入</el-button>
      </el-upload>
      <el-button class="myBtn" type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('import') > -1" @click="templateLift" style="margin-left: 10px;">电梯模板</el-button>
      <!-- <el-button class="myBtn" type="primary" plain size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" :disabled="delStatus" @click="remove">批量删除</el-button> -->
      <el-button class="myBtn" type="primary" size="small" v-if="villageId !== '' && funcData.indexOf('add') > -1" @click="add">新增</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-select class="select" v-model="villageValue" filterable clearable size="small" placeholder="小区名称" v-if="villageId === ''">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="villageName" disabled size="small" placeholder="小区名称" v-else></el-input>
      <el-input class="input" v-model.trim="buildingNumber" size="small" placeholder="楼栋编号"></el-input>
      <el-input class="input" v-model.trim="unitNumber" size="small" placeholder="单元编号"></el-input>
      <el-input class="input" v-model.trim="liftNumber" size="small" placeholder="电梯组号"></el-input>
      <el-input class="input" v-model.trim="liftName" size="small" placeholder="电梯名称"></el-input>
      <el-input class="input" v-model.trim="liftSN" size="small" placeholder="三合一读头"></el-input>
      <el-input class="input" v-model.trim="gateway" size="small" placeholder="网关序列号"></el-input>
      <el-input class="input" v-model.trim="faceSn" size="small" placeholder="人脸设备序列号"></el-input>
      <el-select class="select" v-model="liftTypeValue" filterable clearable size="small" placeholder="电梯类型">
        <el-option v-for="item in liftTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
      </el-select>
      <el-input class="input" v-model.trim="mediaCode" size="small" placeholder="屏幕编号"></el-input>
      <el-input class="input" v-model.trim="mediaType" size="small" placeholder="屏幕类型"></el-input>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="liftAttr" class="list" @selection-change="selectLift">
        <!-- <el-table-column type="selection" width="55" :align="align"></el-table-column> -->
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="orgName" label="小区名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋编号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="unit" label="单元编号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="liftNum" label="电梯组号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="liftName" label="电梯名称" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="registerCode" label="电梯合同号" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="address" label="电梯位置" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="type" label="电梯类型" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ liftType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaCode" label="屏幕编号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.mediaCode) }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaType" label="屏幕类型" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.mediaType) }}
          </template>
        </el-table-column>
        <el-table-column prop="mediaProductor" label="屏幕制造商" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.mediaProductor) }}
          </template>
        </el-table-column>
        <el-table-column prop="sn" label="三合一读头" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.sn) }}
          </template>
        </el-table-column>
        <el-table-column prop="gateway" label="网关序列号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.gateway) }}
          </template>
        </el-table-column>
        <el-table-column prop="faceSn" label="人脸设备序列号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.faceSn) }}
          </template>
        </el-table-column>
        <el-table-column prop="boxSn" label="魔盒设备序列号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.boxSn) }}
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="registerDate" label="创建时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ createTime(scope.row.registerDate) }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" min-width="120" label="操作" v-if="villageId !== ''">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('edit') > -1" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" v-if="villageId !== '' && funcData.indexOf('delete') > -1" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="liftCurr" :page-sizes="[10, 20, 50]" :page-size="liftSize" :total="liftTotal" @current-change="liftCurrChange" @size-change="liftSizeChange"></el-pagination>
    </el-main>
    <!-- 新增编辑电梯弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" size="small">
        <el-form-item label="小区名称" prop="village" v-if="villageId === ''">
          <el-select class="select" v-model="form.village" filterable clearable :disabled="form.isEdit" size="small" placeholder="小区名称" @change="changeVillage">
            <el-option v-for="item in form.villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区名称" :required="true" v-else>
          <el-input v-model.trim="villageName" disabled placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋编号" prop="buildingNumber">
          <el-input v-model.trim.number="form.buildingNumber" :disabled="form.isEdit" placeholder="楼栋编号"></el-input>
        </el-form-item>
        <el-form-item label="单元编号" prop="unitNumber">
          <el-input v-model.trim.number="form.unitNumber" :disabled="form.isEdit" placeholder="单元编号"></el-input>
        </el-form-item>
        <el-form-item label="三合一读头">
          <el-input v-model.trim="form.liftSN" placeholder="三合一读头" @input="liftSNChange"></el-input>
          <el-button class="synBtn" size="small" type="primary" :disabled="form.synSn" v-if="form.isEdit" @click="synBtn('TYPE01', form.liftSN)">同步</el-button>
        </el-form-item>
        <el-form-item label="网关序列号">
          <el-input v-model.trim="form.gateway" placeholder="网关序列号" @input="gatewayChange"></el-input>
          <el-button class="synBtn" size="small" type="primary" :disabled="form.synGateway" v-if="form.isEdit" @click="synBtn('TYPE03', form.gateway)">同步</el-button>
        </el-form-item>
        <el-form-item label="人脸设备序列号">
          <el-input v-model.trim="form.faceSn" placeholder="人脸设备序列号" @input="faceSnChange"></el-input>
          <el-button class="synBtn" size="small" type="primary" :disabled="form.synFace" v-if="form.isEdit" @click="synBtn('TYPE04', form.faceSn)">同步</el-button>
        </el-form-item>
        <el-form-item label="魔盒设备序列号">
          <el-input v-model.trim="form.boxSn" placeholder="魔盒设备序列号" @input="boxSnChange"></el-input>
          <el-button class="synBtn" size="small" type="primary" :disabled="form.synBox" v-if="form.isEdit" @click="synBtn('TYPE05', form.boxSn)">同步</el-button>
        </el-form-item>
        <el-form-item label="电梯组号" prop="liftNumber">
          <el-input v-model.trim.number="form.liftNumber" :maxLength="3" placeholder="电梯组号"></el-input>
        </el-form-item>
        <el-form-item label="电梯名称" prop="liftName">
          <el-input v-model.trim="form.liftName" placeholder="电梯名称"></el-input>
        </el-form-item>
        <el-form-item label="电梯类型" prop="liftType">
          <el-select v-model="form.liftType" filterable clearable placeholder="电梯类型">
            <el-option v-for="item in form.liftTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼层显示规则" prop="floorRule">
          <el-select v-model="form.floorRule" filterable clearable placeholder="楼层显示规则">
            <el-option v-for="item in form.floorRuleList" :key="item.id" :label="item.ruleName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯位置" prop="address">
          <el-input v-model.trim="form.address" placeholder="电梯位置"></el-input>
        </el-form-item>
        <el-form-item label="屏幕编号">
          <el-input v-model.trim="form.mediaCode" placeholder="屏幕编号"></el-input>
        </el-form-item>
        <el-form-item label="屏幕制造商">
          <el-input v-model.trim="form.mediaCompany" placeholder="屏幕制造商"></el-input>
        </el-form-item>
        <el-form-item label="屏幕类型">
          <el-input v-model.trim="form.mediaType" placeholder="屏幕类型"></el-input>
        </el-form-item>
        <el-form-item label="电梯合同号" prop="liftCode">
          <el-input v-model.trim="form.liftCode" placeholder="电梯合同号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入错误信息弹出层 -->
    <el-dialog :visible.sync="infoDialog" :title="infoTitle" width="600px" :close-on-click-modal="false" @close="infoNotBtn">
      <el-table class="infoList" :data="infoList">
        <el-table-column prop="index" label="列表行数" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="info" label="错误信息" min-width="300" :align="align"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LiftManage',
  data () {
    return {
      align: this.$align, // 表格对齐方式,
      importLiftUrl: this.$url + this.$api.lift_import, // 电梯导入的地址
      myHeaders: {
        token: sessionStorage.getItem('token') // token数据
      },
      villageId: '', // 小区Id
      villageName: '', // 小区名称
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      buildingNumber: '', // 楼栋编号查询输入框
      unitNumber: '', // 单元编号查询输入框
      liftNumber: '', // 电梯组号查询输入框
      liftName: '', // 电梯名称查询输入框
      liftSN: '', // 三合一读头查询输入框
      gateway: '', // 网关序列号查询输入框
      faceSn: '', // 人脸设备序列号查询输入框
      liftTypeValue: '', // 电梯类型下拉菜单选中value
      liftTypeList: [], // 电梯类型下拉菜单
      mediaCode: '', // 屏幕编号查询输入框
      mediaType: '', // 屏幕类型查询输入框
      delStatus: true, // 批量删除按钮的状态
      liftAttr: [], // 电梯列表
      liftTotal: 0, // 电梯总数
      liftSize: 10, // 电梯每页条数
      liftCurr: 1, // 电梯当前页数
      selectLiftArr: [], // 选中的电梯数组
      dialog: false, // 电梯弹出层状态
      title: '', // 电梯弹出层标题
      loading: false, // 电梯弹出层确定按钮loading
      form: {
        isEdit: false, // 是否为编辑
        synSn: false, // 三合一读头同步按钮状态
        synGateway: false, // 网关序列号同步按钮状态
        synFace: false, // 人脸设备序列号同步按钮状态
        synBox: false, // 魔盒设备序列号同步按钮状态
        liftId: '', // 电梯Id
        village: '', // 小区名称
        villageList: [], // 小区名称下拉框
        buildingNumber: '', // 楼栋编号
        unitNumber: '', // 单元编号
        liftSN: '', // 三合一读头
        gateway: '', // 网关序列号
        faceSn: '', // 人脸设备序列号
        boxSn: '', // 魔盒设备序列号
        liftNumber: '', // 电梯组号
        liftName: '', // 电梯名称
        liftType: '', // 电梯类型
        liftTypeList: [], // 电梯类型下拉框
        floorRule: '', // 楼层显示规则
        floorRuleList: [], // 楼层显示规则下拉框
        address: '', // 电梯位置
        mediaCode: '', // 屏幕编号
        mediaCompany: '', // 屏幕制造商
        mediaType: '', // 屏幕类型
        liftCode: '' // 电梯合同号
      },
      rules: {
        village: [
          {
            required: true,
            message: '请选择小区名称',
            trigger: 'change'
          }
        ],
        buildingNumber: [
          {
            required: true,
            message: '请输入楼栋编号',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            message: '楼栋编号必须为数字值',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value <= 0 || value >= 100) {
                callback(new Error('楼栋编号的范围是1到99'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        unitNumber: [
          {
            required: true,
            message: '请输入单元编号',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            message: '单元编号必须为数字值',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              if (value <= 0 || value >= 10) {
                callback(new Error('单元编号的范围是1到9'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        liftNumber: [
          {
            required: true,
            message: '请输入电梯组号',
            trigger: ['blur', 'change']
          },
          {
            type: 'number',
            message: '单元编号必须为数字值',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value) || value < 1 || value > 255) {
                callback(new Error('电梯组号的范围是1~255'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        liftName: [
          {
            required: true,
            message: '请输入电梯名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('电梯名称由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        liftType: [
          {
            required: true,
            message: '请选择电梯类型',
            trigger: 'change'
          }
        ],
        floorRule: [
          {
            required: true,
            message: '请选择楼层显示规则',
            trigger: 'change'
          }
        ],
        address: [
          {
            required: true,
            message: '请输入电梯位置',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('电梯位置由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        mediaCode: [
          {
            required: true,
            message: '请输入屏幕编号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value)) {
                callback(new Error('屏幕编号由数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        mediaCompany: [
          {
            required: true,
            message: '请输入屏幕制造商',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('屏幕制造商由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        mediaType: [
          {
            required: true,
            message: '请输入屏幕类型',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('屏幕类型由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        liftCode: [
          {
            required: true,
            message: '请输入电梯合同号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('电梯合同号由英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      infoDialog: false, // 导入错误信息弹出层状态
      infoTitle: '导入错误信息', // 导入错误信息弹出层标题
      infoList: [], // 导入错误信息列表
      synType: '', // 同步类型
      synSN: '', // 同步SN
      emqTime: null, // emq超时定时器
      client: null, // MQTT对象
      host: this.$host, // MQTT地址
      port: this.$port, // MQTT地址端口号
      clientId: 'WEB:' + new Date().getTime().toString(), // MQTT对象Id，当前时间
      username: this.$store.state.user.username, // MQTT访问的用户名
      password: this.$store.state.user.password // MQTT访问的密码
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 小区名称
    if (this.$store.state.user.villageId === '') {
      this.villageId = ''
      this.villageName = ''
    } else {
      this.villageId = this.$store.state.user.villageId
      this.villageName = this.$store.state.user.villageName
    }

    // 获取小区名称下拉菜单
    this.$http.get(this.$api.village_list, {
      params: {
        pageSize: 9999,
        pageNum: 1
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.villageValue = data.data.list[0].id
        this.villageList = data.data.list
        this.form.villageList = data.data.list

        // 获取电梯列表数据
        this.getLiftList(this.liftCurr, this.liftSize)
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取电梯类型下拉框数据
    this.liftTypeList = [
      {
        key: 'elevator',
        value: '直梯'
      },
      {
        key: 'escalator',
        value: '扶梯'
      }
    ]
    this.form.liftTypeList = [
      {
        key: 'elevator',
        value: '直梯'
      },
      {
        key: 'escalator',
        value: '扶梯'
      }
    ]
    // 获取楼层对应规则列表
    if (this.villageId !== '') {
      this.$http.get(this.$api.floor_rule_select, {
        params: {
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.form.floorRuleList = data.data.data
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  methods: {
    getLiftList (page, size) {
      let params
      if (this.villageId === '') {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageValue,
          building: this.buildingNumber,
          unit: this.unitNumber,
          liftNum: this.liftNumber,
          liftName: this.liftName,
          sn: this.liftSN,
          gateway: this.gateway,
          faceSn: this.faceSn,
          type: this.liftTypeValue,
          mediaCode: this.mediaCode,
          mediaType: this.mediaType
        }
      } else {
        params = {
          pageNum: page,
          pageSize: size,
          orgId: this.villageId,
          building: this.buildingNumber,
          unit: this.unitNumber,
          liftNum: this.liftNumber,
          liftName: this.liftName,
          sn: this.liftSN,
          gateway: this.gateway,
          faceSn: this.faceSn,
          type: this.liftTypeValue,
          mediaCode: this.mediaCode,
          mediaType: this.mediaType
        }
      }
      this.$http.get(this.$api.lift_list, {
        params: params
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.liftAttr = data.data.list
          this.liftTotal = data.data.total
          this.liftSize = size
          this.liftCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getLiftList(1, this.liftSize)
    },
    add () {
      this.dialog = true
      this.title = '新增电梯'
      this.form.isEdit = false
    },
    edit (id) {
      this.$http.get(this.$api.lift_detail, {
        params: {
          id: id
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.$http.get(this.$api.floor_rule_select, {
            params: {
              orgId: data.data.data.orgId
            }
          }).then((res) => {
            let datA = res.data

            if (datA.data.success) {
              this.form.floorRuleList = datA.data.data
              this.form.liftId = id
              this.form.village = data.data.data.orgId
              this.form.buildingNumber = Number(data.data.data.building)
              this.form.unitNumber = Number(data.data.data.unit)
              if (data.data.data.sn === null) {
                this.form.liftSN = ''
              } else {
                this.form.liftSN = data.data.data.sn
              }
              if (data.data.data.gateway === null) {
                this.form.gateway = ''
              } else {
                this.form.gateway = data.data.data.gateway
              }
              if (data.data.data.faceSn === null) {
                this.form.faceSn = ''
              } else {
                this.form.faceSn = data.data.data.faceSn
              }
              if (data.data.data.boxSn === null) {
                this.form.boxSn = ''
              } else {
                this.form.boxSn = data.data.data.boxSn
              }
              this.form.liftNumber = Number(data.data.data.liftNum)
              this.form.liftName = data.data.data.liftName
              this.form.liftType = data.data.data.type
              this.form.floorRule = data.data.data.liftRule
              this.form.address = data.data.data.address
              this.form.mediaCode = data.data.data.mediaCode
              this.form.mediaCompany = data.data.data.mediaProductor
              this.form.mediaType = data.data.data.mediaType
              this.form.liftCode = data.data.data.registerCode
              this.dialog = true
              this.title = '编辑电梯'
              this.form.isEdit = true
              this.$nextTick(() => {
                this.form.synSn = false
                this.form.synGateway = false
                this.form.synFace = false
                this.form.synBox = false
              })
            } else {
              this.$message({
                type: 'error',
                message: datA.data.errMsg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    exportLift () {
      let orgId = ''
      if (this.villageId === '') {
        orgId = this.villageValue
      } else {
        orgId = this.villageId
      }
      window.open(this.$url + this.$api.lift_export + '?orgId=' + orgId + '&building=' + this.buildingNumber + '&unit=' + this.unitNumber + '&liftNum=' + this.liftNumber + '&liftName=' + this.liftName + '&sn=' + this.liftSN + '&gateway=' + this.gateway + '&faceSn=' + this.faceSn + '&type=' + this.liftTypeValue + '&mediaCode=' + this.mediaCode + '&mediaType=' + this.mediaType)
    },
    remove (id) {
      this.$confirm('是否删除电梯?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = new FormData()
        // let ids = this.selectLiftArr.join()
        formData.append('liftBaseIds', id)

        this.$http({
          method: 'post',
          url: this.$api.lift_remove,
          data: formData
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.$message({
              message: '电梯已删除',
              type: 'success',
              duration: 1000
            })
            this.getLiftList(1, this.liftSize)
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {})
    },
    templateLift () {
      window.open(this.$url + this.$api.import_template + '?type=1')
    },
    uploadSuccess (res) {
      if (res.success) {
        if (res.data.length === 0) {
          this.$message({
            message: '导入电梯成功',
            type: 'success',
            duration: 1000
          })
        } else {
          this.$message({
            message: '导入电梯完成',
            type: 'success',
            duration: 1000
          })
          for (let i = 0; i < res.data.length; i++) {
            for (let k in res.data[i]) {
              this.infoList.push({
                index: k,
                info: res.data[i][k]
              })
            }
          }
          this.infoDialog = true
        }
      } else {
        this.$message({
          type: 'error',
          message: res.msg,
          duration: 2000
        })
      }
      this.getLiftList(this.liftCurr, this.liftSize)
    },
    uploadError () {
      this.$message({
        type: 'error',
        message: '导入电梯失败',
        duration: 1000
      })
    },
    infoNotBtn () {
      this.infoDialog = false
      this.infoList = []
    },
    changeVillage (val) {
      this.$http.get(this.$api.floor_rule_select, {
        params: {
          orgId: val
        }
      }).then((res) => {
        let data = res.data

        if (data.data.success) {
          this.form.floorRule = ''
          this.form.floorRuleList = data.data.data
        } else {
          this.$message({
            type: 'error',
            message: data.data.errMsg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    notBtn () {
      this.loading = false
      this.form.liftId = ''
      this.$refs.form.resetFields()
      this.dialog = false
      this.form.village = ''
      this.form.buildingNumber = ''
      this.form.unitNumber = ''
      this.form.liftSN = ''
      this.form.gateway = ''
      this.form.faceSn = ''
      this.form.boxSn = ''
      this.form.liftNumber = ''
      this.form.liftName = ''
      this.form.liftType = ''
      this.form.floorRule = ''
      this.form.address = ''
      this.form.mediaCode = ''
      this.form.mediaCompany = ''
      this.form.mediaType = ''
      this.form.liftCode = ''
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true

          let formData = new FormData()
          formData.append('id', this.form.liftId)
          if (this.villageId === '') {
            formData.append('orgId', this.form.village)
          } else {
            formData.append('orgId', this.villageId)
          }
          formData.append('building', this.form.buildingNumber)
          formData.append('unit', this.form.unitNumber)
          formData.append('sn', this.form.liftSN)
          formData.append('gateway', this.form.gateway)
          formData.append('faceSn', this.form.faceSn)
          formData.append('boxSn', this.form.boxSn)
          formData.append('liftNum', this.form.liftNumber.toString())
          formData.append('liftName', this.form.liftName)
          formData.append('type', this.form.liftType)
          formData.append('liftRule', this.form.floorRule)
          formData.append('address', this.form.address)
          formData.append('mediaCode', this.form.mediaCode)
          formData.append('mediaProductor', this.form.mediaCompany)
          formData.append('mediaType', this.form.mediaType)
          formData.append('registerCode', this.form.liftCode)

          if (this.form.liftId === '') {
            this.$http({
              method: 'post',
              url: this.$api.lift_add,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '新增电梯成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getLiftList(this.liftCurr, this.liftSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          } else {
            this.$http({
              method: 'post',
              url: this.$api.lift_edit,
              data: formData
            }).then((res) => {
              let data = res.data

              if (data.success) {
                this.$message({
                  message: '编辑电梯成功',
                  type: 'success',
                  duration: 1000
                })
                this.notBtn()
                this.getLiftList(this.liftCurr, this.liftSize)
              } else {
                this.$message({
                  type: 'error',
                  message: data.msg,
                  duration: 1000
                })
              }
              this.loading = false
            }).catch((err) => {
              this.loading = false
              console.log(err)
            })
          }
        } else {
          return false
        }
      })
    },
    liftSNChange (val) {
      this.form.synSn = true
    },
    gatewayChange (val) {
      this.form.synGateway = true
    },
    faceSnChange (val) {
      this.form.synFace = true
    },
    boxSnChange (val) {
      this.form.synBox = true
    },
    synBtn (type, sn) {
      this.$confirm('是否同步信息?', '提示', {
        confirmButtonText: '同步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.synType = type
        this.synSN = sn
        this.client = new window.Paho.MQTT.Client(this.host, Number(this.port), this.clientId)
        let options = {
          invocationContext: {
            host: this.host,
            port: this.port,
            path: this.client.path,
            clientId: this.clientId
          },
          useSSL: this.$useSSL,
          timeout: 10,
          keepAliveInterval: 60,
          cleanSession: true,
          userName: this.username,
          password: this.password,
          onSuccess: this.onConnect,
          onFailure: this.onFailure
        }
        this.client.connect(options)
      }).catch(() => {})
    },
    onConnect () {
      console.log('连接成功')

      let pubSynTopic = '/' + this.synType + '/' + this.synSN + '/notify'
      let mySynSend = {
        cmd: 'syn'
      }
      let message = new window.Paho.MQTT.Message(JSON.stringify(mySynSend))
      message.destinationName = pubSynTopic
      message.qos = 1
      message.retained = false
      this.client.send(message)
      if (this.synType === 'TYPE01') {
        this.form.synSn = true
      }
      if (this.synType === 'TYPE03') {
        this.form.synGateway = true
      }
      if (this.synType === 'TYPE04') {
        this.form.synFace = true
      }
      if (this.synType === 'TYPE05') {
        this.form.synBox = true
      }
    },
    onFailure () {
      console.log('连接失败')
    },
    liftCurrChange (curr) {
      this.getLiftList(curr, this.liftSize)
    },
    liftSizeChange (size) {
      this.getLiftList(this.liftCurr, size)
    },
    selectLift (selection) {
      if (selection.length > 0) {
        this.delStatus = false
        this.selectLiftArr = []
        for (let i = 0; i < selection.length; i++) {
          this.selectLiftArr.push(selection[i].id)
        }
      } else {
        this.delStatus = true
      }
    },
    liftType (val) {
      for (let i = 0; i < this.liftTypeList.length; i++) {
        if (val.toString() === this.liftTypeList[i].key) {
          return this.liftTypeList[i].value
        }
      }
    },
    createTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    notData (str) {
      return this.$null(str)
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.liftCurr - 1) * this.liftSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.liftManage
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      .cell
        line-height 26px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-form-item
          position relative
          .synBtn
            position absolute
            top 0
            right -60px
            height 32px
        .el-select
          width 100%
      .infoList
        width 100%
        thead
          tr, th
            padding 4px 0
            color #666
            background-color #fafafa
            .cell
                font-weight bold
        tbody
          tr, th
            color #333
        td
          padding 7px 0
        .cell
          line-height 26px
</style>



// WEBPACK FOOTER //
// src/components/lift/liftManage.vue